let isBulkInstallApiTriggered = false;
export const getIsBulkInstallTriggered = () => isBulkInstallApiTriggered;
export const setIsBulkInstallTriggered = value => {
  isBulkInstallApiTriggered = value;
};
//# sourceMappingURL=bulk-installer-triggered.js.map